import useGeoLocation from '@/composables/useGeoLocation';
import { useMutation } from '@tanstack/vue-query';

const useUserGpsLocation = () => {
  const { getPosition } = useGeoLocation();

  return useMutation({
    mutationKey: ['userGpsLocation'],
    mutationFn: getPosition,
  });
};

export default useUserGpsLocation;
